import { Pagination } from '@/constants/pagination';
import { PaginationAPI } from '@/types/pagination';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type CustomerRequestState = {
  data: CustomerRequestType[];
  pagination: PaginationAPI;
  totalElements?: number;
  loading: boolean;
  filters: CustomerRequestFilterState;
  dataDetail?: CustomerRequestDetail;
  dataOverViewDetail?: CustomerRequestOverviewType;
  dataCustomerBins?: CustomerRequestBins[];
};

export const customerRequestInitialState: CustomerRequestState = {
  data: [],
  pagination: {
    Page: Pagination.Page,
    totalPages: 0,
    totalElements: 0,
    Size: Pagination.Size,
  },
  loading: false,
  filters: {},
  dataDetail: undefined,
  dataOverViewDetail: undefined,
  dataCustomerBins: undefined,
};

const slice = createSlice({
  name: 'customerRequest',
  initialState: customerRequestInitialState,
  reducers: {
    setListCustomerRequestAction(
      state,
      {
        payload,
      }: PayloadAction<{
        data: CustomerRequestType[];
        pagination?: PaginationAPI;
        totalElements?: number;
        append?: boolean;
      }>,
    ) {
      if (payload.append) {
        state.data = [...state.data, ...payload.data];
      } else {
        state.data = payload.data;
      }

      state.pagination = payload.pagination || state.pagination;
      state.totalElements = payload.pagination?.totalElements;
    },

    setCustomerRequestLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setDetailCustomerRequestAction(state, { payload }: PayloadAction<CustomerRequestDetail>) {
      state.dataDetail = payload;
    },
    setCustomerOverviewAction(state, { payload }: PayloadAction<CustomerRequestOverviewType>) {
      state.dataOverViewDetail = payload;
    },

    setCustomerRequestFiltersAction(state, action: PayloadAction<CustomerRequestFilterState>) {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetCustomerRequestFiltersAction(state) {
      state.filters = {};
    },
    setCustomerRequestBinsAction(state, { payload }: PayloadAction<CustomerRequestBins[]>) {
      state.dataCustomerBins = payload;
    },
  },
});

export const {
  setListCustomerRequestAction,
  setCustomerRequestLoading,
  setDetailCustomerRequestAction,
  setCustomerOverviewAction,
  setCustomerRequestFiltersAction,
  resetCustomerRequestFiltersAction,
  setCustomerRequestBinsAction,
} = slice.actions;
export default slice.reducer;
